module.exports = __webpack_public_path__ + "static/img/餐饮.79874f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/餐饮.png
// module id = NsZx
// module chunks = 3